<template>
  <nav
    class="navbar is-primary no-print"
    role="navigation"
    aria-label="main navigation"
  >
    <div class="navbar-brand">
      <router-link class="navbar-item" to="/">
        <!-- <img src="@/assets/logo.png" width="30" height="30"> -->
        <span>&nbsp;&nbsp;{{ this.user.username }}</span>
      </router-link>
      <a
        role="button"
        class="navbar-burger"
        aria-label="menu"
        aria-expanded="false"
        :class="{ 'is-active': isMenuActive }"
        @click="isMenuActive = !isMenuActive"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div class="navbar-menu" :class="{ 'is-active': isMenuActive }">
      <div class="navbar-start"></div>

      <div class="navbar-end">
        <div
          class="navbar-item has-dropdown is-hoverable"
          v-if="roleid == '9' || roleid == '10'"
        >
          <a class="navbar-link">
            <span>ການຜະລິດ</span>
          </a>

          <div class="navbar-dropdown">
            <!-- <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/clinic/productionreport"
              :exact="true"
              active-class="is-active"
            >
              <span>ບັນຫາການຜະລິດຕາມຕະຫຼາດ</span>
            </router-link> -->
            <router-link
              v-if="roleid == 9 || roleid == 10"
              @click.native="menuClicked"
              class="navbar-item"
              to="/clinic/b2bproductionbranchreport"
              :exact="true"
              active-class="is-active"
            >
              <span>ບັນຫາການຜະລິດ ຕາມສັນຍາ</span>
            </router-link>
          </div>
        </div>

        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            <span>ຕັ້ງຄ່າຕ່າງໆ</span>
          </a>
          <div class="navbar-dropdown" v-if="roleid == '9'">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/clinic/setting/user"
              :exact="true"
              active-class="is-active"
            >
              <span>ຈັດການຜູ້ໃຊ້ Clinic ສາຂາ</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/clinic/setting/branch"
              :exact="true"
              active-class="is-active"
            >
              <span>ຈັດການສາຂາ</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/clinic/setting/product"
              :exact="true"
              active-class="is-active"
            >
              <span>ຈັດການສິນຄ້າ ທົ່ວໄປ</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/clinic/setting/stockproduct"
              :exact="true"
              active-class="is-active"
            >
              <span>ຈັດການສິນຄ້າ ສາງ</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/clinic/setting/productpricetype"
              :exact="true"
              active-class="is-active"
            >
              <span>ຈັດການປະເພດລາຄາ</span>
            </router-link>

            <!-- <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/clinic/setting/product_data"
              :exact="true"
              active-class="is-active"
            >
              <span>ຈັດການສິນຄ້າ (data)</span>
            </router-link> -->

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/clinic/setting/productionzone"
              :exact="true"
              active-class="is-active"
            >
              <span>ຈັດການໂຊນກະສິກຳ</span>
            </router-link>
          </div>

          <div class="navbar-dropdown" v-if="roleid == '10'">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/clinic/branch/productivity"
              :exact="true"
              active-class="is-active"
            >
              <span>ຈັດການສິນຄ້າໃນໂຊນກະສິກຳ</span>
            </router-link>
          </div>
        </div>
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            <span>ລາຍງານ</span>
          </a>
          <div class="navbar-dropdown" v-if="roleid == '9' || roleid == '10'">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/clinic/report/productivity"
              :exact="true"
              active-class="is-active"
            >
              <span>ລາຍງານສິນຄ້າ (ໂຊນກະສິກຳ)</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/clinic/report/productgroupbytype"
              :exact="true"
              active-class="is-active"
            >
              <span>ລາຍງານ ສິນຄ້າແຍກຕາມປະເພດ</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/clinic/report/allproductivity"
              :exact="true"
              active-class="is-active"
            >
              <span>ລາຍງານ ຄວາມສາມາດຜະລິດ</span>
            </router-link>
          </div>
        </div>
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            <span>ຜູ້ໃຊ້ງານ {{ rolename }}</span>
          </a>
          <div class="navbar-dropdown">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/profile"
              :exact="true"
              active-class="is-active"
            >
              <span>ຂໍ້ມູນສ່ວນຕົວ</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/login"
              :exact="true"
              active-class="is-active"
            >
              <span>ອອກຈາກລະບົບ</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "ReportMenu",
  data() {
    return {
      isMenuActive: false,
      roleid: null,
      rolename: null,
    };
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.rolename = this.user.ROLENAME;
    console.log("roleid: " + JSON.stringify(this.roleid));
  },
  computed: {
    // user: get("loginData"),
  },
  methods: {
    menuClicked() {
      this.isMenuActive = false;
    },
  },
};
</script>

<style scoped>
.navbar-item {
  white-space: nowrap;
}
.navbar-end {
  padding-right: 60px;
}
</style>
